export default "__VITE_ASSET__DW6XDX9e__"